import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { formatDate } from '../../utils/helpers'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import { useParams } from 'react-router-dom'
import useAnnouncement from '../../hooks/announcements/useAnnouncement'
import { Alert } from '@mui/material'

const Announcement = () => {
  const { id: announcementId } = useParams()
  
  const { data: announcement, isSuccess, isError, refetch: refetchAnnouncement, isStale } = useAnnouncement(announcementId)

  useEffect(() => {
    if (isStale) {
      refetchAnnouncement()
    }
  }, [isStale])

  return (
    <div>
      {
        isError && (
          <div>
            <Alert severity='error'>
              Unable to fetch the announcement.
            </Alert>
          </div>
        )
      }
      {
        isSuccess && (
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Typography
                variant='h4'
                sx={{
                  color: '#27417A',
                  fontWeight: 'bold'
                }}
              >
                {announcement.Title}
              </Typography>
            </Grid>
            <Grid 
              item 
              xs={4} 
              sx={{ 
                textAlign: 'right',
              }}>
              <Typography
                sx={{
                  mt: 1,
                  fontStyle: 'italic',
                  color: '#3B444B'
                }}
              >
                {formatDate(announcement.EndDate)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Card
                elevation={0}
                sx={{
                  border: 'solid 2px #27417A'
                }}
              >
                <CardContent>
                  {announcement.Description}
                </CardContent>
                <CardActions>
                  {
                    announcement.Link && (
                      <Button
                        component='a'
                        href={announcement.Link}
                        target="_blank"
                        variant='outlined'
                        sx={{
                          color: '#3A6DAA',
                          borderColor: '#3A6DAA'
                        }}
                      >
                        {announcement.Link}
                      </Button>
                    )
                  }
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        )
      }
    </div>
  )
}

export default Announcement